import Top from './Top';
import './Header.css';
import Middle from './Middle';
import Bottom from './Bottom';
import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


export default class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            data2: props.data2,
            config: props.config,
            options: {
                margin: 20,
                dots: false,
                nav: false,
                slideTransition: 'linear',
                autoWidth: true,
                touchDrag: true,
                mouseDrag: true,
                slideSpeed: 600,
                paginationSpeed: 800,
                singleItem: true
            }
        }
        // console.log("HEADER: ", this.state);

    }

    render(props) {

        var className = "header " + this.state.config.top_component;

        const style = {

            "backgroundColor": '#' + this.state.config.gbcolor

        };

        return (
            <header>
                {this.state.data.main_menu_sub_mobile ?
                    (
                        <OwlCarousel id="sub-mobile-menu" className="owl-theme calendar-carousel" {...this.state.options}>
                            {this.state.data.main_menu_sub_mobile ?
                                (this.state.data.main_menu_sub_mobile.map(function (item, key) {
                                    var name = item.name;
                                    var url = item.url;
                                    return (
                                        <div key={key} className="item"><a href={url}>{name}</a></div>
                                    )
                                })


                                )
                                :
                                (null)
                            }
                        </OwlCarousel>
                    )
                    :
                    (null)}
                <section className={className} style={style}>
                    <Top data={this.state.data} data2={this.state.data2} config={this.state.config} />
                    <Middle data={this.state.data} config={this.state.config} />
                    <Bottom data={this.state.data} config={this.state.config} />
                </section>


            </header>
        );

    }

}



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js